window.groupLogs = function(){
	$('section[data-date]').each(function(){
		let date = $(this).attr('data-date');

		$(`.js-date-title[data-date="${date}"]:not(:first)`).remove();

		$(`section[data-date="${date}"]:not(:first)`).each(function(){
			$(`section[data-date="${date}"]:first`).append($(this).html());
			$(this).remove();
		})
	})

	let d = new Date();
	let today = `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`;
	d.setDate(d.getDate() - 1);
	let yesterday = `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`;

	$(`.js-date-title[data-date="${today}"]`).text(I18n.t('today'));
	$(`.js-date-title[data-date="${yesterday}"]`).text(I18n.t('yesterday'));
}